export type UserLoadedViewState =
  | 'loading'
  | 'setup-loading'
  | 'error'
  | 'empty-team'
  | 'vri-team'
  | 'onboarding'
  | 'dashboard';

type ResolveUserLoadedViewStateArgs = {
  teamId: string | null | undefined;
  isFetchingTeam: boolean;
  teamQueryError: Error | null | undefined;
  isOnboarding: boolean;
  pathname: string;
  canAccessTeam: boolean | undefined;
  /** the team belongs to the ui-vrintegrations app (PRO-18809) */
  isVriTeam: boolean;
};

export const resolveUserLoadedViewState = ({
  teamId,
  isFetchingTeam,
  teamQueryError,
  isOnboarding,
  pathname,
  canAccessTeam,
  isVriTeam,
}: ResolveUserLoadedViewStateArgs): UserLoadedViewState => {
  if (!teamId) {
    if (teamQueryError) return 'error';
    if (isFetchingTeam)
      return ['/setup', '/verify-email', '/sign-up'].includes(pathname)
        ? 'setup-loading'
        : 'loading';
    return 'empty-team';
  }

  if (isVriTeam) return 'vri-team';
  if (isOnboarding && !pathname.startsWith('/settings')) return 'onboarding';
  if (canAccessTeam) return 'dashboard';
  if (teamQueryError) return 'error';
  return 'empty-team';
};
